enum BookingRoleWorkerShiftRejectedReason {
	Undefined           = 0,
	CannotWorkEnoughShifts = 1,
	ShiftsAlreadyFilled = 2,
	CustomerRequirementsChanged = 3,
	SkillQualificationExperienceGap =4
}

export default BookingRoleWorkerShiftRejectedReason;

